// React Imports
import * as React from 'react';
import {useEffect, useState} from "react";
import {Controller, useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import {
    Input, InputAdornment,
    InputLabel,
    Select, TextField
} from "@mui/material";

// App Imports
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import {changeFinancial} from "./financialSlice";
import {addFinancial, editFinancial} from "./FinancialClient";
import {changeCrudSnackbar} from "../../CommonComponents/crudSnackbarSlice";
import {getAllProducts} from "../Product/ProductClient";
import {getAllPlatforms} from "../Platform/PlatformClient";
import {getAllLicenses} from "../License/LicenseClient";
import Stack from "@mui/material/Stack";
import dayjs from "dayjs";
import FormDatePicker from "../../CommonComponents/FormDatePicker";
import {NumericFormat} from "react-number-format";


// Main Function
export default function FinancialDrawer({contractDataPointDrawerState,contractDataPointDrawerMode}) {


    // ****************** BEGIN STATES ****************************

    const [submitting, setSubmitting] = useState(true);

    // ****************** END STATES ****************************


    // ****************** BEGIN STORE ****************************
    const dispatchData = useDispatch();

    const selectorFinancialId = useSelector((state) => state.financialSlc.value.id);
    const selectorFinancialDrawerState = useSelector((state) => state.financialSlc.value.financialDrawerState);
    const selectorFinancialDrawerMode = useSelector((state) => state.financialSlc.value.financialDrawerMode);

    // ****************** END STORE ****************************


    // ****************** BEGIN REGISTER ****************************

    const {register, reset, control, handleSubmit} = useForm();

    // ****************** END REGISTER ****************************


    // ****************** BEGIN CRUD ****************************

    function onSubmit(data) {
        setSubmitting(true)
        console.log("here's my Financial data")
        console.log({data})
        console.log("here's my stringify data")
        console.log(JSON.stringify(data, null, 2))
        if(selectorFinancialDrawerMode==="Add"){
            addFinancial(data)
                .then(() => {
                    console.log("Financial added");
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record added"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Add failed"}));
            }).finally(() =>{
                setSubmitting(false);
                dispatchData(changeFinancial({
                    id: null, fileId: null, account: null, adjustFrom: null, adjustTo: null,
                    adjustNote: null, amount: null, displayAmount: null, amountType: null, financialMarket: null,
                    languageCode: null, licenseId: null, periodEndDate: null, propertyId: null,
                    sourceSystem: null, sourceSystemId: null, territory: null, units: null,
                    createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
                    licenseAmount: null, licenseDisplayAmount: null, availBegin: null,
                    availEnd: null, executionDate: null, licensee: null,
                    propertyName: null, initialMarket: null, genre: null, productionType: null,
                    financialGridRefresh: true, financialDrawerState: false, financialDrawerMode: null}))

            })}
        if(selectorFinancialDrawerMode==="Clone"){
            const { id, ...data } = data; // removes id
            addFinancial(data)
                .then(() => {
                    console.log("Financial cloned");
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Clone added"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Cloning failed"}));
            }).finally(() =>{
                setSubmitting(false);
                dispatchData(changeFinancial({id: null,fileId: null, account: null, adjustFrom: null, adjustTo: null,
                    adjustNote: null, amount: null, displayAmount: null, amountType: null, financialMarket: null,
                    languageCode: null, licenseId: null, periodEndDate: null, propertyId: null,
                    sourceSystem: null, sourceSystemId: null, territory: null, units: null,
                    createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
                    licenseAmount: null, licenseDisplayAmount: null, availBegin: null,
                    availEnd: null, executionDate: null, licensee: null,
                    propertyName: null, initialMarket: null, genre: null, productionType: null,
                    financialGridRefresh: true, financialDrawerState: false, financialDrawerMode: null}))

                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record cloned"}));
            })}
        if(selectorFinancialDrawerMode==="Edit"){
            console.log("This is the Financial Id I am going to edit")
            console.log(selectorFinancialId)
            editFinancial(selectorFinancialId, data)
                .then(() => {
                    console.log("Financial edited")
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record edited"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Edit failed"}));
            }).finally(() =>{
                setSubmitting(false);
                console.log("trigger refresh")
                dispatchData(changeFinancial({
                    financialGridRefresh: true, financialDrawerState: false, financialDrawerMode: null}));
            })}
    };

    // ****************** END CRUD ****************************

    // ****************** BEGIN MISC ****************************

    const onFinishFailed = errorInfo => {
        alert(JSON.stringify(errorInfo, null, 2));
    };


    function closeFinancialDrawer() {
        dispatchData(changeFinancial({financialDrawerState: false }));
    };

    // ****************** END MISC ****************************


    // *********************** BEGIN DROPDOWNS **************************


    const fetchProductsForDropdown = () =>
        getAllProducts()

            .then(data => {
                console.log("Products List")
                console.log(data);
                setProducts(data);

            })
    useEffect(() => {
        console.log("This is for the products dropdown...");
        fetchProductsForDropdown();
    }, []);


    const fetchPlatformsForDropdown = () =>
        getAllPlatforms()

            .then(data => {
                console.log("Platforms List")
                console.log(data);
                setPlatforms(data);

            })
    useEffect(() => {
        console.log("This is for the platforms dropdown...");
        fetchPlatformsForDropdown();
    }, []);


    const fetchLicensesForDropdown = () =>
        getAllLicenses()

            .then(data => {
                console.log("Licenses List")
                console.log(data);
                setLicenses(data);

            })
    useEffect(() => {
        console.log("This is for the licenses dropdown...");
        fetchLicensesForDropdown();
    }, []);

// *********************** END DROPDOWNS **************************


    const financial = useSelector((state) => state.financialSlc.value);

    useEffect(() => {

        reset({
            ...financial,
            periodEndDate: financial.periodEndDate
                ? dayjs(financial.periodEndDate)
                : null,

            adjustFrom: financial.adjustFrom
                ? dayjs(financial.adjustFrom)
                : null,

            adjustTo: financial.adjustTo
                ? dayjs(financial.adjustTo)
                : null,

            amount: financial.amount,
        });


    }, [financial, reset]);


    // ******************* BEGIN AUTOCOMPLETE *********************

    const [dataPointDropdown, setDataPointDropdown] = useState([]);
    const [dataPoints, setDataPoints] = useState([]);
    const [products, setProducts] = useState([]);
    const [platforms, setPlatforms] = useState([]);
    const [licenses, setLicenses] = useState([]);
    const [selectedDataPoint, setSelectedDataPoint] = useState(null);

    // ****************** BEGIN FORM ****************************

    function financialForm(){
        return(
            <form
                onSubmit={handleSubmit((data)=>        onSubmit(data))}
            >
                <Box
                    sx={{width: 1000, height: 300, pl: 5}}
                    role="presentation"
                >

                    <h2 style={{
                        paddingLeft: 0,
                        cursor: 'pointer'
                    }} onClick={() => closeFinancialDrawer()}>Financial Form</h2>
                    <h4>{selectorFinancialDrawerMode} Mode</h4>
                    <br/>
                    {/*<br/>*/}
                    <Input
                        style={{visibility: "hidden"}}
                        {...register('id', {required: true})}
                        id="id" name="id" label="id" aria-describedby="id_entry"
                        defaultValue={Number(useSelector((state) => state.financialSlc.value.id))}
                    />
                    <br/>
                    <Stack direction="row" spacing={2}>
                    <TextField
                        {...register('fileId', {required: true})}
                        id="fileId" name="fileId" label="File ID" aria-describedby="fileId_entry"
                        defaultValue={useSelector((state) => state.financialSlc.value.fileId)}
                        sx={{width: 200}}/>

                    <FormControl variant="standard" sx={{minWidth: 300}}>
                        <InputLabel htmlFor="propertyId">Product</InputLabel>
                        <Select

                            {...register('propertyId', {required: true})}
                            labelId="propertyId"
                            id="propertyId"
                            // value={selectedValue}
                            label="propertyId"
                            defaultValue={useSelector((state) => state.financialSlc.value.propertyId)}
                            sx={{width: 600}}
                        >
                            {products.map((ProductItem) =>
                                <MenuItem value={ProductItem.id}>{ProductItem.id}: {ProductItem.name}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    </Stack>
                    {/*<br/>*/}
                    {/*<br/>*/}
                    <br/>
                    <Stack direction="row" spacing={2}>

                        {/*<NumericFormat*/}
                        {/*    {...register('amount', {required: false})}*/}
                        {/*    id="amount" name="amount" label="Amount" aria-describedby="amount_entry"*/}
                        {/*    defaultValue={useSelector((state) => state.financialSlc.value.amount)}*/}
                        {/*    customInput={TextField}*/}
                        {/*    thousandSeparator={true}*/}
                        {/*    decimalScale={2}*/}
                        {/*    fixedDecimalScale={true}*/}
                        {/*    prefix="$"*/}
                        {/*    sx={{width: 200}}/>*/}
                        <Controller
                            name="amount"
                            control={control}
                            render={({ field }) => (
                                <NumericFormat
                                    value={field.value ?? ''}
                                    onBlur={field.onBlur}
                                    inputRef={field.ref}

                                    customInput={TextField}
                                    label="Amount"
                                    thousandSeparator
                                    decimalScale={2}
                                    fixedDecimalScale
                                    prefix="$"

                                    onValueChange={(values) => {
                                        field.onChange(values.floatValue);
                                    }}
                                />
                            )}
                        />
                        <TextField
                            {...register('amountType', {required: false})}
                            id="amountType" name="amountType" label="Amount Type" aria-describedby="amountType_entry"
                            defaultValue={useSelector((state) => state.financialSlc.value.amountType)}
                            sx={{width: 200}}/>
                        <TextField
                            {...register('units', {required: false})}
                            id="units" name="units" label="Units" aria-describedby="units_entry"
                            defaultValue={useSelector((state) => state.financialSlc.value.units)}
                            sx={{width: 200}}/>
                    </Stack>
                    <br/>
                    {/*<br/>*/}
                    <Stack direction="row" spacing={2}>
                        {/*<TextField*/}
                        {/*    {...register('periodEndDate', {required: false})}*/}
                        {/*    id="periodEndDate" name="periodEndDate" label="Period End Date"*/}
                        {/*    aria-describedby="periodEndDate_entry"*/}
                        {/*    defaultValue={useSelector((state) => state.financialSlc.value.periodEndDate)}*/}
                        {/*    sx={{width: 200}}/>*/}
                        <FormDatePicker
                            name="periodEndDate"
                            label="Period End Date"
                            control={control}
                            width={220}
                            variant = "outlined"
                            />
                        <TextField
                            {...register('account', {required: true})}
                            id="account" name="account" label="Account" aria-describedby="account"
                            defaultValue={useSelector((state) => state.financialSlc.value.account)}
                            sx={{width: 300}}/>
                        <TextField
                            {...register('financialMarket', {required: false})}
                            id="financialMarket" name="financialMarket" label="Financial Market"
                            aria-describedby="financialMarket_entry"
                            defaultValue={useSelector((state) => state.financialSlc.value.financialMarket)}
                            sx={{width: 300}}/>

                    </Stack>
                    <br/>
                    {/*<br/>*/}
                    <Stack direction="row" spacing={2}>
                        <TextField
                            {...register('territory', {required: false})}
                            id="territory" name="territory" label="Territory" aria-describedby="territory_entry"
                            defaultValue={useSelector((state) => state.financialSlc.value.territory)}
                            sx={{width: 300}}/>
                        <TextField
                            {...register('languageCode', {required: false})}
                            id="languageCode" name="languageCode" label="Language Code"
                            aria-describedby="languageCode_entry"
                            defaultValue={useSelector((state) => state.financialSlc.value.languageCode)}
                            sx={{width: 200}}/>

                        <FormControl variant="standard" sx={{m: 1, minWidth: 300}}>
                            <InputLabel htmlFor="licenseId">License</InputLabel>
                            <Select

                                {...register('licenseId', {required: false})}
                                labelId="licenseId"
                                id="licenseId"
                                label="licenseId"
                                defaultValue={useSelector((state) => state.financialSlc.value.licenseId)}
                                sx={{width: 300}}
                            >
                                {licenses.map((LicenseItem) =>
                                    <MenuItem value={LicenseItem.externalId}>{LicenseItem.licensee}</MenuItem>
                                )}
                            </Select>
                        </FormControl>
                    </Stack>
                    <br/>
                    {/*<br/>*/}
                    <Stack direction="row" spacing={2}>
                        {/*<TextField*/}
                        {/*    {...register('adjustFrom', {required: false})}*/}
                        {/*    id="adjustFrom" name="adjustFrom" label="Adjust From" aria-describedby="adjustFrom_entry"*/}
                        {/*    defaultValue={useSelector((state) => state.financialSlc.value.adjustFrom)}*/}
                        {/*    sx={{width: 150}}/>*/}
                        {/*<TextField*/}
                        {/*    {...register('adjustTo', {required: false})}*/}
                        {/*    id="adjustTo" name="adjustTo" label="Adjust To" aria-describedby="adjustTo_entry"*/}
                        {/*    defaultValue={useSelector((state) => state.financialSlc.value.adjustTo)}*/}
                        {/*    sx={{width: 150}}/>*/}
                        <FormDatePicker
                            name="adjustFrom"
                            label="Adjust From"
                            control={control}
                            width={220}
                            variant = "outlined"
                        />
                        <FormDatePicker
                            name="adjustTo"
                            label="Adjust To"
                            control={control}
                            width={220}
                            variant = "outlined"
                        />
                        <TextField
                            {...register('adjustNote', {required: false})}
                            id="adjustNote" name="adjustNote" label="Adjust Note" aria-describedby="adjustNote_entry"
                            defaultValue={useSelector((state) => state.financialSlc.value.adjustNote)}
                            sx={{width: 500}}/>
                    </Stack>
                    <br/>
                    {/*<br/>*/}
                    <Stack direction="row" spacing={2}>
                        <TextField
                            {...register('stakeholderId', {required: false})}
                            id="stakeholderId" name="stakeholderId" label="Stakeholder Id"
                            aria-describedby="stakeholderId_entry"
                            defaultValue={useSelector((state) => state.financialSlc.value.stakeholderId)}
                            sx={{width: 200}}/>
                        <TextField
                            disabled={true}
                            {...register('contractId', {required: false})}
                            id="contractId" name="contractId" label="Contract Id"
                            aria-describedby="contractId"
                            defaultValue={useSelector((state) => state.stakeholderListSlc.value.contractId)}
                            sx={{width: 200}}/>
                    </Stack>
                    <br/>
                    {/*<br/>*/}
                    <Stack direction="row" spacing={2}>
                        <TextField
                            {...register('sourceSystem', {required: false})}
                            id="sourceSystem" name="sourceSystem" label="Source System"
                            aria-describedby="sourceSystem_entry"
                            defaultValue={useSelector((state) => state.financialSlc.value.sourceSystem)}
                            sx={{width: 200}}/>
                        <TextField
                            {...register('sourceSystemId', {required: false})}
                            id="sourceSystemId" name="sourceSystemId" label="Source System Id"
                            aria-describedby="sourceSystemId_entry"
                            defaultValue={useSelector((state) => state.financialSlc.value.sourceSystemId)}
                            sx={{width: 200}}/>
                        <TextField
                            disabled={true}
                            {...register('status', {required: false})}
                            id="status" name="status" label="Status"
                            aria-describedby="status_entry"
                            defaultValue={useSelector((state) => state.stakeholderListSlc.value.status)}
                            sx={{width: 200}}/>
                    </Stack>
                    <br/>
                    {/*<br/>*/}
                    <Stack direction="row" spacing={2}>
                        <TextField
                            disabled={true}
                            TextField{...register('createdBy', {required: false})}
                            id="createdBy" name="createdBy" label="Created By"
                            aria-describedby="createdBy_entry"
                            defaultValue={useSelector((state) => state.stakeholderListSlc.value.createdBy)}
                            sx={{width: 200}}/>

                        <TextField
                            disabled={true}
                            {...register('createdOn', {required: false})}
                            id="status" name="createdOn" label="Created On"
                            aria-describedby="createdOn_entry"
                            defaultValue={useSelector((state) => state.stakeholderListSlc.value.createdOn)}
                            sx={{width: 200}}/>
                        <TextField
                            disabled={true}
                            {...register('lastModifiedBy', {required: false})}
                            id="lastModifiedBy" name="lastModifiedBy" label="Last Modified By"
                            aria-describedby="lastModifiedBy_entry"
                            defaultValue={useSelector((state) => state.stakeholderListSlc.value.lastModifiedBy)}
                            sx={{width: 200}}/>
                        <TextField
                            disabled={true}
                            {...register('lastModifiedOn', {required: false})}
                            id="lastModifiedOn" name="lastModifiedOn" label="Last Modified On"
                            aria-describedby="lastModifiedOn_entry"
                            defaultValue={useSelector((state) => state.stakeholderListSlc.value.lastModifiedOn)}
                            sx={{width: 200}}/>
                    </Stack>

                    <br/>
                    <br/>
                    <Button
                        type="submit"
                    >Submit</Button>
                    <Button onClick={() => closeFinancialDrawer()}>Cancel</Button>
                    <HiddenFields/>
                </Box>
            </form>
        );
    }

    // ****************** END FORM ****************************


    // ****************** BEGIN HIDDEN FIELDS ****************************

    function HiddenFields() {
        return (
            <div>
            </div>
        )
    }

    // ****************** END HIDDEN FIELDS ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <Drawer
                anchor='right'
                open={selectorFinancialDrawerState}
                onClose={closeFinancialDrawer}
            >
                {financialForm()}

            </Drawer>
        </div>
    );

    // ****************** END RETURN ****************************

}
